import {Component, Input, OnInit} from '@angular/core';
import {EdlForm} from '../components/form-builder/models/edl-form.model';
import {StateService, Transition} from '@uirouter/angular';
import { EdlUserForm } from '../model/edl-user-form.model';

@Component({
    templateUrl: './preview-questionnaire.component.html'
})
export class PreviewQuestionnaireComponent implements OnInit{
    @Input() questionnaire: EdlForm;
    @Input() formAnswers: any = {};
    @Input() printMode: Boolean = false;
    userForm: EdlUserForm = new EdlUserForm();

    constructor(private stateService: StateService, private transition: Transition) {}

    ngOnInit() {
        this.userForm = new EdlUserForm();
        this.userForm.FormAnswers = this.formAnswers;
    }

    close = () => {
        if (this.transition.$from().name === 'authenticated.questionnaires.add' || this.transition.$from().name === '') {
            this.stateService.go('authenticated.questionnaires.questionnaire.edit');
            return false;
        }
        else {
            window.history.go(-1);
            return false;
        }
    }
}